//global bindings
const ControlBinders = (() => {
    const componentsToBind = [];

    const runWrapper = (scope, wrapper) => {
        if (Array.isArray(scope)) {
            scope.forEach(item => {
                item.querySelectorAll(wrapper.selector).forEach(elm => wrapper.bind(elm));
            });
        } else {
            scope.querySelectorAll(wrapper.selector).forEach(elm => wrapper.bind(elm));
        }
    }

    const register = (selector, binder) => {
        componentsToBind.push({selector: selector, bind: binder});
    }

    const run = (scope = document) => {
        componentsToBind.forEach(wrapper => runWrapper(scope, wrapper));
    }

    return {
        register,
        run
    };
})();

document.addEventListener('DOMContentLoaded', () => {
    ControlBinders.run();
});


// as long as it continues to be invoked, it will not be triggered
function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

// Serialize all form data into a query string
// (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
// @param  {Node}   form The form to serialize
// @return {String}      The serialized form data
var serialize = function (form) {

    // Setup our serialized data
    var serialized = [];

    // Loop through each field in the form
    for (var i = 0; i < form.elements.length; i++) {

        var field = form.elements[i];

        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

        // If a multi-select, get all selections
        if (field.type === 'select-multiple') {
            for (var n = 0; n < field.options.length; n++) {
                if (!field.options[n].selected) continue;
                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
            }
        }

        // Convert field data to a query string
        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
        }
    }

    return serialized.join('&');

};


//for adding custom events
class BaseClass {
    constructor(element) {
        this.element = element;
        this.element.wrapper = this;
        this.eventListeners = [];
    }

    addEventListener(eventType, callback) {
        this.eventListeners.push({
            eventType, callback
        });
    }

    raiseEvent(eventType, data = undefined) {
        this.eventListeners
            .filter(x => x.eventType === eventType)
            .forEach(x => x.callback(data));
    }
}

//toggle on targeted element,
document.querySelectorAll("[data-tc-target]").forEach(i => {

    i.addEventListener('click', e => {

        let targetElement = e.target.dataset.tcTarget;

        let setClass = e.target.dataset.tcClass;
        if (setClass === undefined) {
            setClass = 'open';
        }

        document.querySelectorAll(targetElement).forEach(t => {
            toggleClass(t, setClass);
        });

        if (e.target.dataset.tcHtmlOverflow) {
            toggleClass(document.querySelector('html'), e.target.dataset.tcHtmlOverflow);
        }

    })
});

//toggle class
function toggleClass(el, className) {
    if (el.classList) {
        el.classList.toggle(className);
    } else {
        var classes = el.className.split(' ');
        var existingIndex = classes.indexOf(className);

        if (existingIndex >= 0)
            classes.splice(existingIndex, 1);
        else
            classes.push(className);

        el.className = classes.join(' ');
    }
}

function viewport() {
    let viewport = 0;

    if (window.matchMedia('(min-width: 1600px)').matches) {
        viewport = 4;
    } else if (window.matchMedia('(min-width: 1260px)').matches) {
        viewport = 3;
    } else if (window.matchMedia('(min-width: 1024px)').matches) {
        viewport = 2;
    } else if (window.matchMedia('(min-width: 768px)').matches) {
        viewport = 1;
    }
    return viewport;
}

document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${window.innerWidth - document.documentElement.clientWidth}px`
);